// Material-UI
import { makeStyles } from 'tss-react/mui';

// App
import { classificationStyles } from "../styles/common";

const useStyles = makeStyles()({
  centerStatement: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: 5,
    zIndex: 9999,
  },
  stickyTop: {
    position: 'fixed',
    top: 0,
  },
  stickyBottom: {
    position: 'fixed',
    bottom: 0,
  },
  ...classificationStyles()
});

function CuiBanner({ stickyTop=false, stickyBottom=false, ...props }) {
  const { classes } = useStyles();
  
  if (window._env_?.CUI_APP) {
    let combinedClasses = classes.centerStatement + ' ' + classes.controlled;

    if (stickyTop) {
      combinedClasses += ' ' + classes.stickyTop;
    }

    if (stickyBottom) {
      combinedClasses += ' ' + classes.stickyBottom;
    }

    return (
      <div className={combinedClasses}>
        <b>CUI</b>
      </div>
    );
  }
  return (<></>);
}

export default CuiBanner;
